import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const { REQUEST_GET_SIGNATURE_ACCESS, SUCCESS_GET_SIGNATURE_ACCESS, FAILURE_GET_SIGNATURE_ACCESS } =
  documentationActions;

function* getAccess(action: any): SagaReturnType<any> {
  try {
    const response = yield call(templateService.getSignatureAccess, action.payload, action.params );
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_SIGNATURE_ACCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_SIGNATURE_ACCESS, payload: error });
  }
}

function* getSignatureAccessSaga() {
  yield takeEvery(REQUEST_GET_SIGNATURE_ACCESS, getAccess);
}

export default getSignatureAccessSaga;
